<div class="am-shell" *ngIf="customerCase?.id">

  <!-- ── Header ──────────────────────────────────────────────────────── -->
  <div class="am-head">
    <div class="am-head__tile">
      <lucide-icon name="message-circle" [size]="16"></lucide-icon>
    </div>
    <div class="am-head__copy">
      <div class="am-head__title">
        {{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.TITLE' | translate }}
      </div>
      <div class="am-head__sub">
        {{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.FOR' | translate }}
        <strong>{{ customer?.longName || customer?.name }}</strong>
        · {{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.CASE_LABEL' | translate }}
        <strong>{{ customerCase?.name }}</strong>
        <ng-container *ngIf="nMonths > 1">
          · {{ nMonths }} {{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.CUOTAS' | translate }}
        </ng-container>
      </div>
    </div>
    <button type="button" class="am-head__close" (click)="cancel()">
      <lucide-icon name="x" [size]="15"></lucide-icon>
    </button>
  </div>

  <!-- ── Body ────────────────────────────────────────────────────────── -->
  <div class="am-body">

    <!-- KPI tiles — full width -->
    <div class="am-kpi-row">
      <div class="am-kpi">
        <span class="am-kpi__icon">
          <lucide-icon name="dollar-sign" [size]="16"></lucide-icon>
        </span>
        <div class="am-kpi__content">
          <span class="am-kpi__label">
            {{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.TOTAL_AMOUNT' | translate }}
          </span>
          <span class="am-kpi__value">
            {{ pendingAmountNumeric }}
            <span class="am-kpi__unit">{{ pendingCurrencyCode }}</span>
          </span>
        </div>
      </div>
      <div class="am-kpi">
        <span class="am-kpi__icon">
          <lucide-icon name="clock" [size]="16"></lucide-icon>
        </span>
        <div class="am-kpi__content">
          <span class="am-kpi__label">
            {{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.VALIDITY' | translate }}
          </span>
          <span class="am-kpi__value">
            {{ expirationDays }}
            <span class="am-kpi__unit">
              {{ (expirationDays === 1
                ? 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.DAY'
                : 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.DAYS') | translate }}
            </span>
          </span>
        </div>
      </div>
    </div>

    <!-- Two-column layout: config (left) + plan (right) -->
    <div class="am-cols">

      <!-- LEFT: CONFIGURACIÓN -->
      <div class="am-col am-col--config">
        <h3 class="am-eyebrow">
          {{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.SECTION_CONFIG' | translate }}
          <span class="line"></span>
        </h3>

        <!-- Canal de envío -->
        <div class="am-field">
          <label class="am-field__label">
            {{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.FORM.CHANNEL.LABEL' | translate }}
            <span class="am-req">*</span>
          </label>
          <div class="am-channel-list">
            <button
              type="button"
              class="am-channel"
              [class.is-selected]="selectedChannel === 'sms'"
              (click)="selectChannel('sms')"
              *ngIf="hasSms"
            >
              <span class="am-channel__icon">
                <lucide-icon name="smartphone" [size]="16"></lucide-icon>
              </span>
              <div class="am-channel__body">
                <span class="am-channel__name">SMS</span>
                <span class="am-channel__detail">{{ sms }}</span>
              </div>
              <span class="am-channel__radio" [class.is-checked]="selectedChannel === 'sms'"></span>
            </button>
            <button
              type="button"
              class="am-channel"
              [class.is-selected]="selectedChannel === 'email'"
              (click)="selectChannel('email')"
              *ngIf="hasEmail"
            >
              <span class="am-channel__icon">
                <lucide-icon name="mail" [size]="16"></lucide-icon>
              </span>
              <div class="am-channel__body">
                <span class="am-channel__name">Email</span>
                <span class="am-channel__detail">{{ email }}</span>
              </div>
              <span class="am-channel__radio" [class.is-checked]="selectedChannel === 'email'"></span>
            </button>
          </div>
        </div>

        <!-- Número de cuotas -->
        <div class="am-field">
          <label class="am-field__label">
            {{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.FORM.CHANNEL.INSTALMENTS' | translate }}
            <span class="am-req">*</span>
          </label>
          <div class="am-segment">
            <button type="button" class="am-segment__btn" [class.is-active]="nMonths === 1 && !customMode" (click)="setMonths(1)">1</button>
            <button type="button" class="am-segment__btn" [class.is-active]="nMonths === 3 && !customMode" (click)="setMonths(3)">3</button>
            <button type="button" class="am-segment__btn" [class.is-active]="nMonths === 6 && !customMode" (click)="setMonths(6)">6</button>
            <button type="button" class="am-segment__btn" [class.is-active]="nMonths === 12 && !customMode" (click)="setMonths(12)">12</button>
            <button type="button" class="am-segment__btn" [class.is-active]="customMode" (click)="enableCustomMode()">
              {{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.CUSTOMIZE' | translate }}
            </button>
          </div>
          <div class="am-custom-months" *ngIf="customMode">
            <input
              type="number"
              class="am-input"
              [(ngModel)]="customMonths"
              (change)="applyCustomMonths()"
              min="1"
              max="24"
            />
          </div>
          <p class="am-kpi-hint" *ngIf="installments.length">
            {{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.MONTHLY_ESTIMATE' | translate }}
            <strong>{{ installments[0]?.amount?.amount | currencyWithCode: installments[0]?.amount?.currency }}</strong>
          </p>
        </div>

        <!-- Caduca el -->
        <div class="am-field">
          <label class="am-field__label">
            {{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.FORM.CHANNEL.EXPIRES_72H' | translate }}
            <span class="am-req">*</span>
          </label>
          <p-calendar
            [(ngModel)]="expirationDate"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [minDate]="minDate"
            styleClass="am-calendar"
          ></p-calendar>
          <span class="am-field__help">
            {{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.EXPIRES_HELP' | translate }}
          </span>
        </div>
      </div>

      <!-- RIGHT: PLAN DE COBRO -->
      <div class="am-col am-col--plan">
        <h3 class="am-eyebrow">
          {{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.SECTION_PLAN' | translate }}
          <span class="line"></span>
        </h3>

        <div class="am-table" *ngIf="installments.length">
          <table>
            <thead>
              <tr>
                <th class="am-table__th am-table__th--num">
                  {{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.TABLE_NUM' | translate }}
                </th>
                <th class="am-table__th">
                  {{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.TABLE_DATE' | translate }}
                </th>
                <th class="am-table__th am-table__th--right">
                  {{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.TABLE_AMOUNT' | translate }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let inst of installments; let i = index" class="am-table__row">
                <td class="am-table__td am-table__td--num">{{ i + 1 }}</td>
                <td class="am-table__td">
                  <div class="am-table__date-cell">
                    <span class="am-table__date">{{ getEstimatedDate(i) | date:'dd/MM/yyyy' }}</span>
                    <span class="am-badge" *ngIf="i === 0">
                      {{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.TABLE_FIRST_PAYMENT' | translate }}
                    </span>
                  </div>
                </td>
                <td class="am-table__td am-table__td--right">
                  {{ inst?.amount?.amount | currencyWithCode: inst?.amount?.currency }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div><!-- /am-cols -->

    <!-- Summary — full width -->
    <div class="am-summary" *ngIf="!checkDisabled()">
      <lucide-icon name="info" [size]="14"></lucide-icon>
      <div class="am-summary__body" [innerHTML]="summaryHtml"></div>
    </div>

  </div>

  <!-- ── Footer ──────────────────────────────────────────────────────── -->
  <div class="am-footer">
    <button type="button" class="am-btn am-btn-text" (click)="cancel()">
      {{ 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.CANCEL' | translate }}
    </button>
    <pay-button
      [label]="'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.SEND_AGREEMENT' | translate"
      variant="primary"
      [disabled]="checkDisabled()"
      (clicked)="send()"
    ></pay-button>
  </div>

</div>
